<template>
  <div>
    <component
      v-for="(field, fieldIndex) in fields"
      :key="fieldIndex"
      :is="fieldsMap[field.type].component"
      :properties="field.properties"
      :property="field.property"
      :value="typeof selectedElement.properties[field.property] !== 'undefined' ? selectedElement.properties[field.property] : fieldsMap[field.type].defaultValue"
      :element="selectedElement"
      :formId="formId"
      @update-value="updatePropertyValue"
    />
  </div>
</template>

<script>
import { mapGetters, mapMutations, mapState } from "vuex";
import TextAreaPropertyType from "./propertyTypes/Textarea";
import RichEditorPropertyType from "./propertyTypes/RichEditor";
import TextInputPropertyType from "./propertyTypes/TextInput";
import CheckboxPropertyType from "./propertyTypes/Checkbox";
import MultipleTextPropertyType from "./propertyTypes/MultipleText";
import DropdownPropertyType from "./propertyTypes/Dropdown";
import DatePickerPropertyType from "./propertyTypes/DatePicker";
import MultipleWeightedText from "./propertyTypes/MultipleWeightedText";
import ConditionEditor from "./propertyTypes/ConditionEditor";
import DatatableColumns from './propertyTypes/DatatableColumns';
import TableData from './propertyTypes/TableData';
import Autopopulation from "./propertyTypes/Autopopulation";

export default {
  name: "FormBuilderElementPropertiesManager",
  props: ["fields", "formId"],
  data() {
    return {
      fieldsMap: {
        textInput: {
          component: TextInputPropertyType,
          defaultValue: ""
        },
        textarea: {
          component: TextAreaPropertyType,
          defaultValue: ""
        },
        richEditor: {
          component: RichEditorPropertyType,
          defaultValue: ""
        },
        checkbox: {
          component: CheckboxPropertyType, 
          defaultValue: false
        },
        multipleText: {
          component: MultipleTextPropertyType,
          defaultValue: []
        },
        dropdown: {
          component: DropdownPropertyType,
          defaultValue: null
        },
        datepicker: {
          component: DatePickerPropertyType,
          defaultValue: null
        },
        multipleWeightedText: {
          component: MultipleWeightedText,
          defaultValue: []
        },
        conditionEditor: {
          component: ConditionEditor,
          defaultValue: null
        },
        datatableColumns: {
          component: DatatableColumns,
          defaultValue: []
        },
        tableData: {
          component: TableData,
          defaultValue: []
        },
        autopopulation: {
          component: Autopopulation,
          defaultValue: null
        }
      }
    };
  },
  methods: {
    ...mapMutations("formBuilder", ["setFormBuilderSelectedElement"]),
    updatePropertyValue(property, newValue, validateInput = true) {
      if (validateInput && !this.isTechStaff && !this.advancedOptions && typeof newValue === 'string') {
        newValue = newValue.replace("{{","").replace("}}","");
      }
      let newSelectedElement = { ...this.selectedElement };
      newSelectedElement.properties[property] = newValue;
      if (property == 'hidden') {
        newSelectedElement.properties['required'] = false;
      }
      this.setFormBuilderSelectedElement({
        newSelectedElement: newSelectedElement,
        formId: this.formId
      });
    }
  },
  computed: {
    ...mapGetters("formBuilder", {
      selectedElementFB: "formBuilderSelectedElement"
    }),
    ...mapState("formBuilder", {
      forms: state => state.form
    }),
     ...mapState("layout", {
      advancedOptions: state => state.advancedOptions
    }),
    ...mapGetters("layout", ["isTechStaff"]),
    selectedElement() {
      return this.selectedElementFB({ formId: this.formId });
    }
  }
};
</script>

<style></style>
